export default {
  metadata: {
    version: '1.0.0',
    id: 'dropdown-menu-submenu-1.0.0',
    name: 'JDSDropdownMenuSubMenuInternal'
  },
  hierarchy: {
    'menu-container': ['menu-group-slot']
  },
  base: {
    'menu-container': {
      hidden: false,
      'background-color': '{primaryGrey20}',
      'flex-direction': '{flexDirection.column}',
      'border-radius': '{large}',
      'pointer-events': 'auto',
      overflow: 'hidden',
      'padding-top': '{xs}',
      'padding-bottom': '{xs}',
      'overflow-y': 'auto',
      opacity: '{opacity.invisible}',
      'enter-animation-name': 'fadeIn',
      'exit-animation-name': 'fadeOut',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500,
      'box-shadow': {
        x: 0,
        y: 4,
        blur: 16,
        spread: 0,
        color: '{custom_color_5}'
      }
    },
    'menu-group-slot': {
      hidden: false
    }
  },
  variant: {
    _platform: {
      mobile: {
        'menu-container': {
          size: '{size.max}'
        }
      }
    },
    _menuContainerVisible: {
      true: {
        'menu-container': {
          opacity: '{opacity.enabled}'
        }
      }
    }
  },
  api: {
    children: {
      'menu-group-slot': {
        name: 'children',
        accepts: ['jds_dropdown_menu_group']
      }
    },
    data: {
      'menu-container': {
        width: {
          type: 'size',
          name: '_menuWidth'
        },
        'max-height': {
          type: 'size',
          name: '_menuMaxHeight'
        },
        elementRef: {
          type: 'ref',
          name: 'triggerRef'
        }
      }
    },
    events: {
      'menu-container': {
        onAppear: {
          name: 'onAppear',
          platform: 'ios'
        },
        onClick: 'onSelect'
      }
    },
    config: {
      _platform: {
        values: ['mobile', 'desktop']
      },
      _menuContainerVisible: {
        values: [false, true]
      }
    },
    a11y: {
      'menu-container': {
        properties: {
          role: {
            value: 'menu'
          }
        }
      }
    }
  }
};
